import { useEffect, useRef } from 'react';

import { useMotionValue, useScroll } from 'framer-motion';

/**
 *
 * @see https://github.com/samselikoff/fixed-header-teaser
 */
export const useDirectionalScrollProgress = ({ inputRange, threshold }) => {
	let { scrollY } = useScroll();
	let scrollYOnDirectionChange = useRef(scrollY.get());
	let lastPixelsScrolled = useRef<number>(0);
	let lastScrollDirection = useRef<'down' | 'up' | null>(null);
	let pixelsScrolled = useMotionValue<number>(0);

	useEffect(() => {
		return scrollY.on('change', (latest) => {
			if (latest < 0) return;

			let isScrollingDown = (scrollY?.getPrevious() ?? 0) - latest < 0;
			let scrollDirection: 'down' | 'up' = isScrollingDown ? 'down' : 'up';
			let currentPixelsScrolled = pixelsScrolled.get();
			let newPixelsScrolled;

			if (lastScrollDirection.current !== scrollDirection) {
				lastPixelsScrolled.current = currentPixelsScrolled;
				scrollYOnDirectionChange.current = latest;
			}

			if (isScrollingDown) {
				newPixelsScrolled = Math.min(
					lastPixelsScrolled.current +
						(latest - scrollYOnDirectionChange.current) -
						(threshold?.down ?? 0),
					inputRange[1],
				);
			} else {
				newPixelsScrolled = Math.max(
					lastPixelsScrolled.current -
						(scrollYOnDirectionChange.current - latest) +
						(threshold?.up ?? 0),
					inputRange[0],
				);
			}

			pixelsScrolled.set(newPixelsScrolled);
			lastScrollDirection.current = scrollDirection;
		});
	}, [pixelsScrolled, scrollY, inputRange, threshold]);

	return pixelsScrolled;
};
